module.exports = __webpack_public_path__ + "static/media/data-table-no-record-found.bd55d29b.svg";